import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';
import { useRef, useState } from 'react';

import {
      csvBuilder,
      csvLoader,
      mapStandaloneCartsToCsvTable,
      tableStandaloneCartsColumnNames,
} from '../utils/csvProcessor';

const EXPORT_STATUS = {
      SUCCEED: 'Succeed',
      PENDING: 'Pending',
      NO_DATA: 'No data to export',
      ERROR: 'Something went wrong - '
}

const useExportStandaloneCarts = (getHistoryCarts, shopOrigin, filter, hosts) => {
      const csvFileRef = useRef('');

      const [exportStatus, setExportStatus] = useState(null);
      const [exportError, setExportError] = useState(null);
      const [isExportInProgress, setIsExportInProgress] = useState(false);

      const toCsvConverter = (docs) => {
            const dataRows = docs.map(doc => {
                  return mapStandaloneCartsToCsvTable(doc, shopOrigin, hosts);
            });

            return csvBuilder(dataRows);
      };

      const csvProcessor = (docs, next) => {
            const csvBatch = toCsvConverter(docs);
            csvFileRef.current += csvBatch;

            if (!next) {
                  if (!csvFileRef.current) {
                        setExportStatus(EXPORT_STATUS.NO_DATA);
                  } else {
                        csvFileRef.current = tableStandaloneCartsColumnNames() + csvFileRef.current;
                        setExportStatus(EXPORT_STATUS.SUCCEED);
                        csvLoader(csvFileRef.current,`${shopOrigin}_`);
                  }
                  setIsExportInProgress(false);
            } else {
                  next().then(({ docs, next }) => {
                        csvProcessor(docs, next);
                  }).catch((error) => {
                        setExportStatus(EXPORT_STATUS.ERROR);
                        setExportError(error);
                        setIsExportInProgress(false);
                  });
            }
      };

      const exportHistoryStandaloneCarts = () => {
            csvFileRef.current = '';
            setExportError(null);
            setExportStatus(EXPORT_STATUS.PENDING);
            setIsExportInProgress(true);

            // any custom name for events
            firebase.analytics().logEvent('admin.export_standalone_carts_history', { range: filter.range?.id });

            getHistoryCarts(400)
                  .then(({ docs, next }) => {
                        csvProcessor(docs, next);
                  })
                  .catch((error) => {
                        setExportStatus(EXPORT_STATUS.ERROR);
                        setExportError(error);
                        setIsExportInProgress(false);
                  });
      };

      return ({
            isExportInProgress,
            exportStatus,
            exportError,
            exportHistoryStandaloneCarts
      })
};

export default useExportStandaloneCarts;
